import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'
import { AppConfigService } from '@alfresco/adf-core';
import { ADMINISTRATION_DATA_LIST_SITE_URL } from '../../model/contants/deusto';

@Component({
  template: ''
})
export class AdministrationComponent implements OnInit {

  constructor(private location: Location, private appConfigService: AppConfigService) {}

  ngOnInit() {
    // Abrir la nueva pestaña y redirigir a la ruta anterior
    this.openShare();
    this.location.back();
  }

  openShare() {
    const ecmHost = this.appConfigService.get<string>('ecmHost');
    const url = ecmHost + ADMINISTRATION_DATA_LIST_SITE_URL;
    // _blank para nueva ventana, _self para la misma ventana
    window.open(url, "_blank");
  }

}